import * as Yup from 'yup'

export const validationSchema = Yup.object({
  NumberOfTrees: Yup.string().required(
    'Please provide the number trees planted'
  ),
  Description: Yup.string().required('Please provide a description'),
  MonitoringDescription: Yup.string().required('Please provide a description'),
  PlantingDocuments: Yup.array(),
  PlantingAssets: Yup.array(),
  WorkflowState: Yup.string()
})
